/* Coria · "Adauga in cos" rapid pe carduri (ex. Brillian by Saeshin).
   Foloseste acelasi traseu ca formularul de produs al temei: /cart/add.js + reincarcarea cosului lateral. */
(function () {
  'use strict';
  if (window.__cfQuickAdd) return;
  window.__cfQuickAdd = true;
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var addUrl = (window.routes && window.routes.cart_add_url) || (root + 'cart/add');

  function setBusy(btn, busy) {
    btn.disabled = busy;
    btn.classList.toggle('is-busy', busy);
    btn.setAttribute('aria-busy', busy ? 'true' : 'false');
  }

  document.addEventListener('submit', function (ev) {
    var form = ev.target;
    if (!form || !form.matches || !form.matches('form[data-cf-quick-add]')) return;
    ev.preventDefault();
    var btn = form.querySelector('[type="submit"]');
    var msg = form.querySelector('.cf-trend-atc__msg');
    if (!btn || btn.disabled) return;
    setBusy(btn, true);
    if (msg) msg.textContent = '';

    var cart = document.querySelector('cart-drawer');
    var fd = new FormData(form);
    if (cart && typeof cart.getSectionsToRender === 'function') {
      fd.append('sections', cart.getSectionsToRender().map(function (s) { return s.section; }));
      fd.append('sections_url', window.location.pathname);
    }

    fetch(addUrl.replace(/\.js$/, '') + '.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: fd
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, json: j }; }); })
      .then(function (res) {
        if (!res.ok || res.json.status) {
          if (msg) msg.textContent = res.json.description || res.json.message || 'Nu am putut adauga produsul.';
          return;
        }
        document.dispatchEvent(new CustomEvent('cart:item-added', { detail: { item: res.json, source: 'cf-quick-add' } }));
        if (cart && typeof cart.renderContents === 'function' && res.json.sections) {
          try {
            cart.renderContents(res.json);
            if (!cart.classList.contains('show') && typeof cart.open === 'function') cart.open();
            else { var icon = document.querySelector('#cart-count-icon, [data-source="cart-drawer"]'); if (!cart.classList.contains('show') && icon) icon.click(); }
          } catch (e) { window.location.href = root + 'cart'; }
        } else {
          window.location.href = root + 'cart';
        }
        btn.classList.add('is-done');
        setTimeout(function () { btn.classList.remove('is-done'); }, 1800);
      })
      .catch(function () { if (msg) msg.textContent = 'Conexiune intrerupta. Incearca din nou.'; })
      .finally(function () { setBusy(btn, false); });
  });
})();
